import React from 'react';
import { AnimatedSection } from '../AnimatedSection';

const WhoWeAre = () => {
  return (
    <div id="aboutus" className="bg-[#231f20] flex flex-col justify-start items-center text-center text-[#f4f1e9] font-columbia-serial pt-12 pb-36 scroll-mt-20 overflow-x-hidden"> 
      <AnimatedSection className="flex flex-col items-center text-center">
      <img 
        src="/assets/creamlogo.png" 
        alt="Cream Logo" 
        className="mb-4 w-20 h-20 sm:w-24 sm:h-24 md:w-32 md:h-32 lg:w-40 lg:h-40"
        loading="lazy"
      />
      <h1 className="text-4xl sm:text-5xl md:text-6xl leading-tight mb-6 sm:mb-8 font-columbia-serial">
        Who We Are
      </h1>
      <p className="text-lg sm:text-xl leading-relaxed w-[90%] sm:w-[80%] md:w-[70%] lg:w-[60%] mx-auto font-columbia-serial">
        Date Saver Co was built to rebel against the <span className='text-[#fde39f] italic'>performance of social media. </span> 
        We create space for people to show up as themselves, not the version they feel expected to be.
      </p>
      <br />
      <p className="text-lg sm:text-xl leading-relaxed w-[90%] sm:w-[80%] md:w-[70%] lg:w-[60%] mx-auto font-columbia-serial">
      We want to help you remember what's real, before it disappears. We believe in the beauty of what<span className='text-[#fde39f] italic'> isn't posted</span>.
      The quiet joys. The glances that say everything without a word. 
      These are the moments we want to preserve as memories that stay honest, and unpolished, just as they were.
      </p>
      <br />
      <p className="text-lg sm:text-xl leading-relaxed w-[90%] sm:w-[80%] md:w-[70%] lg:w-[60%] mx-auto font-columbia-serial italic">
        When you stop performing, you return to the story that was always yours.</p>
      </AnimatedSection>
    </div>
  );
};

export default WhoWeAre;
